import { useContext } from 'react';
import { PaymentRequestsTableContext, IPaymentRequestTableContext } from './PaymentRequestsTableContext';

export const usePaymentRequestsTable = () => useContext<IPaymentRequestTableContext>(PaymentRequestsTableContext);
